import * as React from 'react'

import hasFeature from 'modules/core/lib/hasFeature'

interface AutomationContextProps {
  canEditAutomations: boolean
}

const automationContext = React.createContext<AutomationContextProps>({
  canEditAutomations: false,
})

const AutomationProvider = automationContext.Provider

export const InsertAutomationProvider = ({ children }: React.PropsWithChildren<object>) => {
  const canEditAutomations = hasFeature('automations_ui')

  return (
    <AutomationProvider
      value={{
        canEditAutomations,
      }}
    >
      {children}
    </AutomationProvider>
  )
}

export const useAutomationContext = () => React.useContext(automationContext)
